import { Flex } from '@chakra-ui/react';

interface LoadingBarProps {
    isLoading: boolean;
    barColour: string;
}

export const LoadingBar: React.FC<LoadingBarProps> = ({ isLoading, barColour }) => {
    return (
        <Flex className={'loading-bar'}>
            {isLoading && <Flex className={'loading-bar-animated'} backgroundColor={barColour} />}
        </Flex>
    );
};
